const KL_GIFT_WRAP_CART_PARENT_PROPERTY = '_kl_gift_wrap_for';
const KL_GIFT_WRAP_ROUTES_SELECTOR = '[data-kl-cart-routes]';
const KL_GIFT_WRAP_CART_SOURCE = 'cart-items';

function getGiftWrapParentId(item) {
  const parentId = item?.properties?.[KL_GIFT_WRAP_CART_PARENT_PROPERTY];

  return parentId ? String(parentId) : '';
}

function getOrphanGiftLines(cartItems) {
  if (!Array.isArray(cartItems)) return [];

  const presentProductIds = new Set(
    cartItems.filter((item) => !getGiftWrapParentId(item)).map((item) => String(item?.product_id))
  );

  return cartItems.reduce((orphans, item, index) => {
    const parentId = getGiftWrapParentId(item);

    if (parentId && !presentProductIds.has(parentId)) {
      orphans.push({ line: index + 1, key: String(item?.key ?? '') });
    }

    return orphans;
  }, []);
}

function getCartRoutes() {
  const routesElement = document.querySelector(KL_GIFT_WRAP_ROUTES_SELECTOR);

  return {
    changeUrl: routesElement?.dataset.klCartChangeUrl || '',
    cartUrl: routesElement?.dataset.klCartUrl || '',
  };
}

async function removeLineByKey(lineKey) {
  const { changeUrl } = getCartRoutes();

  if (!changeUrl || !lineKey) throw new Error('Missing the cart change route or the line key');

  const response = await fetch(`${changeUrl}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: 0 }),
  });

  if (!response.ok) throw new Error(`Cart change failed with ${response.status}`);
}

function clearOrphan(orphan) {
  const removeButton = document.querySelector(`cart-remove-button[data-index="${orphan.line}"]`);

  if (removeButton) {
    removeButton.click();
    return;
  }

  removeLineByKey(orphan.key).catch((error) => {
    console.debug('kl-gift-wrap-cart: an orphaned packaging line could not be removed', {
      line: orphan.line,
      lineKey: orphan.key,
      error,
    });
  });
}

function handleCartUpdate(event, requestedKeys) {
  const cartData = event?.cartData;
  if (event?.source !== KL_GIFT_WRAP_CART_SOURCE || typeof cartData?.item_count !== 'number') return;

  const orphans = getOrphanGiftLines(cartData.items);
  const liveKeys = new Set((cartData.items || []).map((item) => String(item?.key ?? '')));

  requestedKeys.forEach((key) => {
    if (!liveKeys.has(key)) requestedKeys.delete(key);
  });

  const orphan = orphans.find(({ key }) => !requestedKeys.has(key));

  if (!orphan) return;

  requestedKeys.add(orphan.key);
  clearOrphan(orphan);
}

async function reconcileOnLoad(requestedKeys) {
  const { cartUrl } = getCartRoutes();

  if (!cartUrl) return;

  const response = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });

  if (!response.ok) throw new Error(`Cart request failed with ${response.status}`);

  handleCartUpdate({ source: KL_GIFT_WRAP_CART_SOURCE, cartData: await response.json() }, requestedKeys);
}

function initGiftWrapCart() {
  const requestedKeys = new Set();
  const routesElement = document.querySelector(KL_GIFT_WRAP_ROUTES_SELECTOR);

  if (routesElement && 'klCartReconcileOnLoad' in routesElement.dataset) {
    reconcileOnLoad(requestedKeys).catch((error) => {
      console.debug('kl-gift-wrap-cart: the cart could not be reconciled on load', { error });
    });
  }

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
    console.debug('kl-gift-wrap-cart: the theme cart events are unavailable, so later changes are not reconciled');
    return;
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    try {
      handleCartUpdate(event, requestedKeys);
    } catch (error) {
      console.debug('kl-gift-wrap-cart: the cart could not be reconciled', { error });
    }
  });
}

initGiftWrapCart();
